import {makeObservable, observable} from "mobx";
import {BaseDomainDataSource} from "./base-domain-data-source";
import {BaseProps} from "./props/base-props";
import {runInAction} from "mobx"

export class BaseState {
  @observable _dataSource: BaseDomainDataSource;
  onDataSourcePopulatedCallBacks: Array<Function>;
  onDataSourcePopulatingCallBacks: Array<Function>;
  @observable props: BaseProps;

  static injectables = [];

  constructor() {
    makeObservable(this);

    this.onDataSourcePopulatedCallBacks = [];
    this.onDataSourcePopulatingCallBacks = [];
  }


  get dataSource(): BaseDomainDataSource {
    return this._dataSource;
  }

  set dataSource(value: BaseDomainDataSource) {
    this.onDataSourcePopulatingCallBacks.forEach((callback) => callback(value));


    runInAction(() => {
      this._dataSource = value;
    });

    this.onDataSourcePopulatedCallBacks.forEach((callback) => callback(value));
  }

  registerToStatePopulating(callback: Function) {
    this.onDataSourcePopulatingCallBacks.push(callback);
  }

  registerToStatePopulated(callback: Function) {
    this.onDataSourcePopulatedCallBacks.push(callback);
  }

  onStateCreated() {
  }
}
